<template>
<!-- TODO:
   - In the expanded row, remove starting comma from _mfi-nexgen-unsubscribed.
   - Show import name in the expanded rows.
   - Show event names and/or app names in the events dialog.
   - For Updates:
      Check if any deletes in process (also for Deletes, check if any updates in process).
      Make Updates available if has Tags permission
   - BUG: Clicking on the timepicker's AM/PM btn doesn't trigger the update:period event.
   - Use @change for time-picker + Make a function to distinguish change and use it in submitDialogDate().
   - Sort importHeaders before sending to BtFilterDefiner
   - If possible, re-write this page with the new BtChart (after removing extras and adding actions).
-->
<!-- HISTORY:
   V260326.1: Added event_path and event_element fields for the add_event option in dialogUpdate.
   V260218.1: Removed the disabled property from the type field in dialogUpdate, allowing users to modify the pre-specified type (primarily for US ZIP code fields).
   V250924.2: Added/updated the snackbar-event messages for Delete and Update +
      Added the date param to getOffers() on filter change as well to bypass cache + Didn't call filterChanged() after Delete/Update operations.
   V250922.1: Removed Delete and Update buttons when Feed Search is on.
   V250916.2: Added 'Clear Events' and 'Add Event' to updatableOfferFields.
   V240927.2: Reverted changes from V240903.1 + Added Update btn + Removed Results from Delete btn +
      Moved elapsed time calculation logic from submitDialogDelete() to _getElapsedTime().
   V240903.1: Added operators computed variable and consumed it in the operators prop in bt-filter-wrapper-with-panel (for Feed Search case) to remove operators that use regex.
   V240828.1: Added fields variable and getFields() to only make indexed fields available for feed search.
   V240827.1: [on Aref side] Modified submitDialogEdit() again to always cast values regardless of their preset types.
   V240826.1: Modified submitDialogEdit() again to always cast numbers regardless of the last import's caseType value.
   V240822.1: Modified submitDialogEdit() to only cast number strings that are more than 16 chars.
   V240228.2: Consumed getCollectionInfo() and displayed dbRecords property in front of the page title.
   V240215.1: [on Aref side] Removed pa permission from the Delete Results btn.
   V240214.4: In deleteOffers() of the Feed Search, fixed a bug that didn't set deleteFilter.
   V240214.3: In deleteOffers() of the Feed Search, passed 0 instead of numberOfOffers.
   V240214.2: Fixed the condition in getOffers to bypass offersCount for the Feed Search + Made Delete Results available to the Feed Search as well.
   V240214.1: Implemented Feed Search by modifying the bt-filter-wrapper-with-panel and v-data-table components props and adding the required logic:
      Added Feed switch + Customized page-text + Made few props variables + Made Delete Results btn unavailable for feed search.
   V240104.1: Made showFirstLastPage in footer-props conditional based on offersCount.
   V240102.1: Made Delete Offers btn available to power admin only.
   V231220.1: Modified filterChanged() to calculate offersCount differently.
   V231027.1: Made delete btn disabled if synced/converted offers are filtered (_mfi_studio_sync === false) +
      Before sending delete request, changed filter to only include un-synced/converted records + Cleaned some of commented codes.
   V230720.1: Handled dropdown/select's isMultiple option and boolean type in adding events.
   V230525.1: [was not sent to Aref] Consumed is-actual-endpoint in BtChart + Changed token parsing statement + Set default options for chart.
   V230523.1: Excluded event_data from the events table (in eventsClicked()) to be added to the expanded rows.
   V230512.1: Added extraFields to the table headers.
   V230511.1: Passed show-extra-fields prop to BtFilterWrapperWithPanel.
   V230202.1: Considered systemField property (new) for the static fields.
   V230104.1: Passed the 3rd param to getImportHeaders() to consider rejected imports as well.
   V230103.1: Passed the 2nd param to getFieldValues() to include rejected imports + Changed custom rule to test regex correctly +
      In init(), made import injection only if there was any imports + Removed an unnecessary if in addEventClicked() +
      Replaced crm.event_code with "Event Code" as it has been removed from Settings + Removed required rule from currEventCode + Consumed hasOwn().
   V221107.1: Applied/Modified styles to display contents properly after Aref's upgrade.
   V221018.1: Fixed a bug that didn't disable Add Event icon when there was no settings.
   V221017.1: Added 'Add Event' feature by adding a new icon to the Actions header + Added '_mfi_studio_sync' field to the static fields +
      Removed sorting details logic and saved original details data in order to keep their sequence.
   V221007.1: Modified submitDialogEdit() to loop in offerHeaders instead of editedOffer to update the table row + Made Submit btn in dialogDate enabled if had no value.
   V221006.3: Added computed canAddOffer and canEditOffer to disable NEW RECORD and edit buttons.
   V221006.2: Instead of including event in the new offer, added event afterward + Bypassed caching after deleting offers +
      Added expanded prop to the v-data-table and reset it after add/update offer + Changed the v-if for dialogDate to fix a bug.
   V221006.1: Added 'addedByUI' to the static fields + Persisted record-add or record-update events + Fixed trimming bug in textFieldChanged() +
   V221004.1: Fixed casting bugs that casted numbers regardless of their types, by not assigning any types to the fields with no value +
      Made all editable fields to be mandatory (values cannot be removed but changed only) + In dialogDate, set current date and time for the empty date fields +
      Added hint to the fields with no type + Fixed a bug in getNumOfChanged() that only returned numOfChanges for one category.
   V221003.1: Applied type casting for empty fields.
   V220930.2: Fixed two bugs for empty fields: Failed to check detail.value to set change flag + Didn't show types.
   V220930.1: In submitDialogEdit(), passed purl to updateOffer() to be passed as shardKey + Added date and time pickers for date fields +
      Made empty fields (fields from import headers that has no values) available in edit + Categorized fields in 3 panels.
   V220927.1: In editClicked(), made '__v' field internalField/static.
   V220926.1: Disabled New Offer btn if multi imports are selected + In editClicked(), made dedupHash & rowNumber fields internalField/static +
      In submitDialogEdit(), passed importId to createOffer().
   V220923.1: Added add and edit offer features.
   09/15/22(B1.27): Set the initial importId according to the new changes in BtFilterDefiner (importId's multi-select).
   06/06/22(B1.26): Changed getOffers() to make sure that this.offers will be emptied if this.offersCount is zero.
   06/02/22(B1.25): Consumed BtFilterWrapperWithPanel's btHelpers and filterResult props.
   05/24/22(B1.24): Obtained behFields from bt-mixin + In eventsClicked(), changed the logic of getting events texts.
   05/05/22(B1.23): Fixed the bug with initializing filter (moved new lines to the end).
   05/04/22(B1.22): Consumed initialFilter prop and set filter to use the latest import.
   05/02/22(B1.22): Implemented logout feature.
   04/14/22(B1.21): Commented Actions header (from Aref side).
   04/01/22(B1.20): Only made indexed headers sortable.
   03/25/22(B1.19): Moved filter change from B1.13 in the getOffersCount() function of cs-api-service.js file.
   03/17/22(B1.18): Showed Delete Results btn only if the user has contact-offers-delete policy.
   03/08/22(B1.17): Disabled dialog buttons while deleting offers are in progress, and displayed elapsed time +
      Allowed deleting offers only if there is no other delete in progress.
   03/03/22(B1.16): Fixed the issue with Delete Results btn that didn't hide if no offers.
   03/03/22(B1.15): Called filterChanged() after offers were deleted successfully + Added hide-default-footer prop to v-data-table.
   03/03/22(B1.14): Implemented DELETE RESULTS functionality + Modified dialog to dialogEvents.
   02/18/22(B1.13): in getOffersCount(), modified empty filter to increase the speed of the query.
   02/17/22(B1.12): Added "# of Fields" to the end of expanded items of the offers table.
   02/03/22(B1.11): Moved the indexed settings from B1.10 into BtHelpers.getImportHeaders().
   02/01/22(B1.10): Added isIndexed property to the import fields to be used inside BtFilterDefiner + Removed some of commented codes.
   08/05/21(B1.9): Some clean-up + Removed Alert() + Set has-pagina-table for bt-chart.
   08/02/21(B1.8): Consumed bt-helpers.js and removed related methods.
   07/22/21(B1.7): Removed aid from all methods params and passed filter to getImports().
   07/13/21(B1.6): Added a dialog to display events details in an extendable table.
   07/08/21(B1.5): Added required logic (including behFieldsForGroupby) to support added event fields to the groupby fields.
   06/22/21(B1.4): Changed import_id to importId.
   06/21/21(B1.3): Added names to the import_id values + Added internalField: true property to the internal import headers.
   06/14/21(B1.2): Added import_id to the standard fields + Consumed stdFieldValues prop.
   06/08/21(B1.1): Fixed a bug that didn't persist chart values.
   06/08/21(B1.0): Consumed BtFilterWrapperWithPanel and changed the code accordingly (filterChanged() won't be triggered 1st time) +
      Updated BtChart props.
   05/26/21(B0.15): Added Actions column to the table and Delete Results btn + Changed the page title and added icon.
   05/25/21(B0.14): Replaced v-data-table with Google table.
   05/20/21(B0.13): Consumed BtChart component.
   05/13/21(B0.12): Supported sorting of the table headers.
   05/12/21(B0.11): Supported distinct and the 2nd dropdown in the groupby tab + Fixed the bug w/displaying groupby date fields.
   05/06/21(B0.10): Fixed bug with offer details after groupby.
   05/04/21(B0.9): Added getImportIds() to pass them to BtFilterDefiner.
   04/29/21(B0.8): Removed footer for aggregate + Displayed the name of days and months.
   04/28/21(B0.7): Applied changed to support groupby.dateType.
   04/26/21(B0.6): Displayed field name instead of _id + Formatted groupby numbers.
   04/20/21(B0.5): Passed closedOnLoad prop + Fixed item-expanded bug.
   04/19/21(B0.4): Added <style> + Fixed the bug that called getOffers() with no filter + Added basePurl and purlNumber to importHeaders +
      Implemented data-table's built-in pagination + Added getOffersCount().
   04/12/21(B0.3): Set items-per-page + Called getOffers on limit change + Reduced # of init headers +
      Displayed offers details + Distinguished headers types.
   04/08/21(B0.2): Filter w/selectable columns + Added limit dropdown + Made field names lowercase.
   03/xx/21(B0.1): 1st release.
-->
<v-container fluid class="px-3 py-3">
   <v-card>
      <v-card-title>
         <h1 class="title font-weight-bold grey--text darken-4 pl-2" style="color:#757575 !important">
            <v-icon class="pr-1">search</v-icon>
            <span>Search & Analyze</span>
         </h1>
         <div v-if="Object.keys(collectionInfo).length"
            class="pl-2 pt-1 text-sm-body-2 grey--text darken-4">
            (DB records: {{formatNumber(collectionInfo.db_records)}}, DB size: {{collectionInfo.db_size_GB}} GB, Sharded: {{collectionInfo.sharded}})</div>
         <div class="flex-grow-1"></div>
         <v-switch dense
            class="mb-0"
            v-model="isFeed"
            @change="feedChanged"                                 
         >
            <template v-slot:label>
               <div class="text-sm-body-2 pr-5">Feed Search</div>
            </template>
         </v-switch>
         <v-btn v-if="offers.length"
            x-small
            class="mr-2 mt-1"
            color="gray darken-1"
            :disabled="!canAddOffer || loadingOffers || !importHeaders.length || filter.standard[0].$match.importId?.$in.length > 1"
            @click="newOfferClicked()"
         >NEW RECORD
            <v-icon right dark>add</v-icon>
         </v-btn>
      </v-card-title>

      <v-card-text>
         <!--V240927.1 :operators="operators" -->
         <bt-filter-wrapper-with-panel
            show-extra-fields
            :show-test-cases="!isActualEndpoint"
            :bt-helpers="btHelpers"
            :closed-on-load="closedOnLoad"
            :debug="debug"
            :expansion-panel-header="expansionPanelHeader"
            :fields="fields"
            :filter-result="offers"
            :included-tabs="includedTabs"
            :initial-filter="initialFilter"
            :is-admin="jwt.pa"
            :max="4"
            :preselected-fields="selectedHeaders"
            :should-init="shouldInitFilterDefiner"
            :std-field-values="stdFieldValues"
            v-model="filter"
            @filter-change="filterChanged(...arguments, true)"
            @panel-open="panelStatusChanged"
         ></bt-filter-wrapper-with-panel>
      </v-card-text>

      <v-card-text v-show="!showGroupbyTable" class="pt-0 pb-2">
         <v-data-table dense show-expand single-expand
            class="elevation-1 mb-2"
            :expanded="expandedItem"
            :footer-props="footerProps"
            :headers="offerHeaders"
            :hide-default-footer="offersCount <= 5"
            :item-key="itemKey"
            :items="offers"
            :items-per-page="5"
            :loading="loadingOffers"
            :loading-text="$t('loading-text')"
            :no-data-text="$t('no-data-text', { value: 'offers' })"
            :no-results-text="$t('no-results-text', { value: 'offers' })"
            :options.sync="options"
            :server-items-length="offersCount"
            :search="search"
            @update:expanded="offerExpanded"
         >
            <template v-slot:[`item.actions`]="{ item }">
               <v-icon small
                  :disabled="!canAddEvent || !Object.keys(crm).length"
                  @click="addEventClicked(item)"
               >flash_on</v-icon>
               <v-icon small
                  class="mr-2"
                  :disabled="!canEditOffer"
                  @click="editClicked(item)"
               >edit</v-icon>
            </template>
            <template v-slot:expanded-item="{ item }">
               <td v-for="(colspan, i) in colspans" :key="`${item._id}:${i}`"
                  dense
                  class="py-2" valign="top"
                  :colspan="colspan"
               >
                  <ul v-if="item.details">
                     <li v-for="detail in item.details[i]" :key="detail.key">
                        <span class="expanded-header">{{detail.key}}: </span>
                        <span v-if="detail.key==='events'"
                           class="expanded-content"
                        >
                           <!-- <v-btn link height="27px" @click="eventsClicked(detail.value)">{{detail.value.length}}</v-btn> -->
                           <v-btn text icon dense
                              :disabled="!detail.value.length"
                              @click="eventsClicked(detail.value)"
                           >{{detail.value.length}}
                              <v-icon v-if="detail.value.length">more_horiz</v-icon>
                           </v-btn>
                        </span>
                        <span v-else
                           class="expanded-content"
                        >{{detail.value}}
                        </span>
                     </li>
                     <li v-if="i === colspans.length - 1">
                        <span class="expanded-header"># of Fields: </span>
                        <span class="expanded-content">{{item.details[0].length+item.details[1].length+item.details[2].length}}</span>
                     </li>
                  </ul>
               </td>
            </template>
            <template v-slot:[`footer.page-text`]="items" v-if="isFeed"> 
               {{ items.pageStart }}-{{ items.pageStop }}{{feedsCount ? ' of ' + feedsCount : ''}}
            </template>
         </v-data-table>

         <!-- <v-layout v-if="jwt.pa || !isActualEndpoint"> -->
         <v-row v-if="offersCount && !isFeed"><!-- V250922 -->
            <v-col>
               <span v-if="$store.getters.user.policies.includes(`contact-offers-delete`)" class="pr-2">
                  <v-btn small
                     color="error"
                     :disabled="isDeleteBtnDisabled"
                     :loading="loadingDeleteBtn"
                     @click="deleteResultsClicked"
                  >
                     <v-icon left>delete</v-icon>
                     Delete
                  </v-btn>
               </span>
               <v-btn v-if="$store.getters.user.policies.includes(`contact-offers-update`)"
                  small
                  color="primary"
                  :loading="loadingUpdateBtn"
                  @click="updateResultsClicked"
               >
                  <v-icon left>edit</v-icon>
                  Update
               </v-btn>
            </v-col>
         </v-row>
         <v-row v-if="isDeleteBtnDisabled || isAnotherDelete"
            class="pt-0 error--text"
         >
            <v-col cols="12" class="pt-0">
               <span v-if="isDeleteBtnDisabled">
                  Converted records cannot be deleted.
               </span>
               <span v-else-if="isAnotherDelete">
                  A delete request is already in progress. Please try again after a while.
               </span>
            </v-col>
         </v-row>
      </v-card-text>

      <v-dialog no-click-animation persistent scrollable
         max-width="1280px"
         v-model="dialogEvents"
      >
         <v-card flat tile>
            <v-card-title class="title grey--text darken-4 font-weight-bold pb-4">Events:</v-card-title>
            <v-card-text class="px-4 py-2">
               <v-data-table dense show-expand single-expand
                  class="elevation-1 mb-2"
                  :expanded.sync="expanded"
                  :footer-props="{
                     itemsPerPageOptions:[5, 10, 20],
                     showFirstLastPage: true
                  }"
                  :headers="eventHeaders"
                  :hide-default-footer="events.length < 11"
                  item-key="__csDocumentsExtras.id"
                  :items="events"
                  :items-per-page="10"
                  :loading="loadingEvents"
                  :loading-text="$t('loading-text')"
                  :no-data-text="$t('no-data-text', { value: 'events' })"
                  :no-results-text="$t('no-results-text', { value: 'events' })"
                  :search="search"
                  @update:expanded="eventExpanded"
               >
                  <template v-slot:expanded-item="{ item }">
                     <td dense
                        class="py-2" valign="top"
                        :colspan="eventHeaders.length+1"
                     >
                        <ul v-if="item.__csDocumentsExtras.details && item.__csDocumentsExtras.details.length">
                           <li v-for="(detail, j) in item.__csDocumentsExtras.details" :key="`${detail.key}_${j}`">
                              <span class="expanded-header">{{detail.key}}: </span>
                              <span class="expanded-content">{{detail.value}}</span>
                           </li>
                        </ul>
                        <ul v-else>
                           <li>
                              <span class="expanded-header"></span>
                              <span class="expanded-content">No details are available</span>
                           </li>
                        </ul>
                     </td>
                  </template>
               </v-data-table>
            </v-card-text>
            <v-card-actions class="py-0 pr-3">
               <div class="flex-grow-1"></div>
               <v-btn text
                  class="px-0"
                  color="blue darken-1"
                  @click="closeDialogEvents"
               >Close</v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <v-card-text v-if="showChart" class="pt-0 pb-3">
         <bt-chart
            :show-test-cases="!isActualEndpoint"
            :can-edit-chart="true"
            :can-edit-filter="true"
            :data="offers"
            :debug="debug"
            :fields="importHeaders"
            :flat="false"
            :has-pagina-table="false"
            :is-actual-endpoint='isActualEndpoint'
            :is-admin="jwt.pa"
            :max="4"
            :preselected-fields="selectedHeaders"
            :should-init="shouldInitFilterDefiner"
            :std-field-values="stdFieldValues"
            v-model="chart"
            @filter-change="filterChanged"
         ></bt-chart>
      </v-card-text>

      <v-dialog no-click-animation persistent scrollable
         max-width="480px"
         v-model="dialogDelete"
      >
         <v-card flat tile :loading="isDeleteInProcess">
            <v-card-title class="title grey--text darken-4 font-weight-bold pb-4">Delete the Results</v-card-title>
            <v-card-text class="px-5 pt-2 pb-1">
               <v-icon>warning_amber</v-icon> Please note that only unconverted records can be deleted.
               <div class="pl-5 ml-2">
                  <span v-if="isFeed">
                     To delete all unconverted records of the filtered records, type '<span class="font-weight-bold">delete</span>' in the following box.
                     <br><b>NOTE:</b> You can find out the actual number of deleted records on the <i>Deletes</i> page once the process is completed.
                  </span>
                  <span v-else>
                     To delete {{new Intl.NumberFormat().format(deletesCount)}} unconverted records of {{new Intl.NumberFormat().format(offersCount)}} filtered records, type <span class="font-weight-bold">{{deletesCount}}</span> in the following box:
                  </span>
               </div>
               <v-text-field dense outlined hide-details
                  ref="numberOfOffers"
                  class="py-2"
                  v-model="numberOfOffers"
               ></v-text-field>
               <div v-if="isDeleteInProcess"
                  class="error--text font-weight-bold"
               >
                  <v-progress-circular indeterminate
                     color="red"
                     :size="20"
                     :width="2"
                  ></v-progress-circular>
                  Please wait while your request is being processed: {{deleteElapsedTime}}
               </div>
            </v-card-text>
            <v-card-actions class="pt-0 pb-2 pr-3">
               <div class="flex-grow-1"></div>
               <v-btn text
                  class="px-0"
                  color="blue darken-1"
                  :disabled="isDeleteInProcess"
                  @click="cancelDialogDelete"
               >Cancel</v-btn>
               <v-btn text
                  class="px-0"
                  color="blue darken-1"
                  :disabled="isDeleteInProcess || (isFeed ? numberOfOffers != 'delete' : numberOfOffers != deletesCount)"
                  @click="submitDialogDelete"
               >Submit</v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <v-dialog no-click-animation persistent scrollable
         max-width="960px"
         v-model="dialogEdit"
      >
         <v-form lazy-validation
            ref="formEdit"
            v-model="isFormEditValid"
         >
            <v-card flat tile
               :loading="loadingDialogEdit"
            >
               <v-card-title
                  class="title grey--text darken-4 font-weight-bold pb-4"
               >{{dialogEditTitle}}
               </v-card-title>
               <v-card-text v-if="currOffer"
                  class="px-4 pt-0 pb-1"                  
               >
                  <v-expansion-panels multiple focusable
                     class="pt-0"
                     v-model="panelsEdit"
                  >
                     <v-expansion-panel class="px-0">
                        <v-expansion-panel-header v-if="action === 'add'"
                           hide-actions
                           class="py-0 font-weight-bold"
                        >All Fields<span class="pl-1 body-2 font-italic grey--text">(Total: {{currOffer.editable.length}}, Dedup: {{currOffer.editable.filter(o => o.isDedup).length}}, PURL: {{currOffer.editable.filter(o => o.isPurl).length}})</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-header v-else
                           class="py-0 font-weight-bold"
                        >Fields with Value<span class="pl-1 body-2 font-italic grey--text">(Total: {{currOffer.editable.length}}, Dedup: {{currOffer.editable.filter(o => o.isDedup).length}}, PURL: {{currOffer.editable.filter(o => o.isPurl).length}})</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="px-0">
                           <v-row v-for="(iIndex, i) in Math.ceil(currOffer.editable.length / 3)" :key="`editable_row_${i}`"
                              class="pt-2 py-0" 
                           >
                              <v-col v-for="(jIndex, j) in 3" :key="`editable_col_${j}`"
                                 cols="4" 
                                 class="py-0 px-2" 
                              >
                                 <div v-if="i * 3 + j < currOffer.editable.length">
                                    <v-select v-if="currOffer.editable[i * 3 + j].type === 'boolean'"
                                       dense hide-selected outlined persistent-hint
                                       autocomplete="off"
                                       class="py-0"
                                       :clearable="action === 'add'"
                                       :filled="currOffer.editable[i * 3 + j].changed"
                                       :items="booleanItems"
                                       :label="currOffer.editable[i * 3 + j].text"
                                       :ref="`value_${i}_${j}`"
                                       :rules="currOffer.editable[i * 3 + j].required ? [rules.requiredBoolean] : []"
                                       v-model="currOffer.editable[i * 3 + j].value"
                                       @change="textFieldChanged('editable', i, j, currOffer.editable[i * 3 + j].value)"
                                       @click:clear="textFieldCleared('editable', i, j)"
                                    ></v-select>
                                    <v-text-field v-else-if="currOffer.editable[i * 3 + j].type === 'date'"
                                       dense outlined persistent-hint readonly
                                       append-icon="mdi-calendar"
                                       autocomplete="off"
                                       class="py-0"
                                       :clearable="action === 'add'"
                                       :filled="currOffer.editable[i * 3 + j].changed"
                                       :hint="currOffer.editable[i * 3 + j].value"
                                       :label="currOffer.editable[i * 3 + j].text"
                                       :ref="`value_${i}_${j}`"
                                       :rules="currOffer.editable[i * 3 + j].required ? [rules.required] : []"
                                       type="text"
                                       v-model="currOffer.editable[i * 3 + j].dateValue"
                                       @click:clear="textFieldCleared('editable', i, j)"
                                       @click="dateFieldClicked(currOffer.editable[i * 3 + j])"
                                    >
                                    </v-text-field>
                                    <v-text-field v-else
                                       dense outlined
                                       autocomplete="off"
                                       class="py-0"
                                       :clearable="action === 'add'"
                                       :filled="currOffer.editable[i * 3 + j].changed"
                                       :hint="currOffer.editable[i * 3 + j].type ? '' : 'Value will be automatically cast.'"
                                       :label="currOffer.editable[i * 3 + j].text"
                                       :ref="`value_${i}_${j}`"
                                       :rules="currOffer.editable[i * 3 + j].required ? [rules.required] : []"
                                       :type="currOffer.editable[i * 3 + j].type === 'number' ? 'number' : 'text'"
                                       v-model="currOffer.editable[i * 3 + j].value"
                                       @keyup="textFieldChanged('editable', i, j, currOffer.editable[i * 3 + j].value)"
                                       @click:clear="textFieldCleared('editable', i, j)"
                                    >
                                    </v-text-field>
                                 </div>
                              </v-col>
                           </v-row>
                        </v-expansion-panel-content>
                     </v-expansion-panel>

                     <v-expansion-panel v-if="action === 'edit'"
                        class="px-0"
                     >
                        <v-expansion-panel-header
                           class="py-0 font-weight-bold"
                        >Fields without Value<span class="pl-1 body-2 font-italic grey--text">(Total: {{currOffer.empty.length}})</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="px-0">
                           <v-row class="pt-2 py-0" v-for="(iIndex, i) in Math.ceil(currOffer.empty.length / 3)" :key="`empty_row_${i}`">
                              <v-col class="py-0 px-2" cols="4" v-for="(jIndex, j) in 3" :key="`empty_col_${j}`">
                                 <!-- :background-color="currOffer.editable[i * 3 + j].changed ? 'yellow' : ''" -->
                                 <div v-if="i * 3 + j < currOffer.empty.length">
                                    <v-select v-if="currOffer.empty[i * 3 + j].type === 'boolean'"
                                       clearable dense hide-selected outlined persistent-hint
                                       autocomplete="off"
                                       class="py-0"
                                       :filled="currOffer.empty[i * 3 + j].changed"
                                       :items="booleanItems"
                                       :label="currOffer.empty[i * 3 + j].text"
                                       :ref="`empty_value_${i}_${j}`"
                                       v-model="currOffer.empty[i * 3 + j].value"
                                       @change="textFieldChanged('empty', i, j, currOffer.empty[i * 3 + j].value)"
                                       @click:clear="textFieldCleared('empty', i, j)"
                                    ></v-select>
                                    <v-text-field v-else-if="currOffer.empty[i * 3 + j].type === 'date'"
                                       clearable dense outlined persistent-hint readonly
                                       append-icon="mdi-calendar"
                                       autocomplete="off"
                                       class="py-0"
                                       :filled="currOffer.empty[i * 3 + j].changed"
                                       :hint="currOffer.empty[i * 3 + j].value"
                                       :label="currOffer.empty[i * 3 + j].text"
                                       :ref="`empty_value_${i}_${j}`"
                                       type="text"
                                       v-model="currOffer.empty[i * 3 + j].dateValue"
                                       @click:clear="textFieldCleared('empty', i, j)"
                                       @click="dateFieldClicked(currOffer.empty[i * 3 + j])"
                                    >
                                    </v-text-field>
                                    <v-text-field v-else
                                       clearable dense outlined
                                       autocomplete="off"
                                       class="py-0"
                                       :filled="currOffer.empty[i * 3 + j].changed"
                                       :hint="currOffer.empty[i * 3 + j].type ? '' : 'Value will be automatically cast.'"
                                       :label="currOffer.empty[i * 3 + j].text"
                                       :ref="`empty_value_${i}_${j}`"
                                       :type="currOffer.empty[i * 3 + j].type === 'number' ? 'number' : 'text'"
                                       v-model="currOffer.empty[i * 3 + j].value"
                                       @keyup="textFieldChanged('empty', i, j, currOffer.empty[i * 3 + j].value)"
                                       @click:clear="textFieldCleared('empty', i, j)"
                                    ></v-text-field>
                                 </div>
                              </v-col>
                           </v-row>
                        </v-expansion-panel-content>
                     </v-expansion-panel>

                     <v-expansion-panel v-if="action === 'edit'">
                        <v-expansion-panel-header
                           class="py-0 font-weight-bold"
                        >Uneditable Fields<span class="pl-1 body-2 font-italic grey--text">(Total: {{currOffer.static.length}})</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                           <v-row class="py-0" v-for="(iIndex, i) in Math.ceil(currOffer.static.length / 3)" :key="`static_row_${i}`">
                              <v-col class="py-0" cols="4" v-for="(jIndex, j) in 3" :key="`static_col_${j}`">
                                 <v-text-field v-if="i * 3 + j < currOffer.static.length"
                                    dense disabled persistent-hint
                                    :hint="currOffer.static[i * 3 + j].text"
                                    :ref="`value_${i}_${j}`"
                                    class="py-0"
                                    v-model="currOffer.static[i * 3 + j].value"
                                 ></v-text-field>
                              </v-col>
                           </v-row>
                           <br>
                        </v-expansion-panel-content>
                     </v-expansion-panel>
                  </v-expansion-panels>
               </v-card-text>
               <v-card-actions class="pt-0 pb-2 pr-5">
                  <div class="flex-grow-1"></div>
                  <v-btn text
                     class="px-0"
                     color="blue darken-1"
                     @click="cancelDialogEdit"
                  >Cancel</v-btn>
                  <v-btn text
                     class="pl-0 pr-2"
                     color="blue darken-1"
                     :disabled="!numOfChanges || !isFormEditValid"
                     @click="submitDialogEdit"
                  >Submit</v-btn>
                  <span v-if="numOfChanges"
                     class="pr-2 body-2 font-italic grey--text"
                  > ({{numOfChanges}} {{action === 'add' ? 'fields' : 'changes'}})
                  </span>
               </v-card-actions>
            </v-card>
         </v-form>
      </v-dialog>

      <v-dialog v-if="dialogDate"
         no-click-animation persistent scrollable
         max-width="640px"
         v-model="dialogDate"
      >
         <v-form lazy-validation
            ref="formDate"
            v-model="isFormDateValid"
         >
            <v-card flat tile>
               <!-- Pick a Date and Time for '{{currOffer[currDateField.category][currDateField.index].text.replace('* ').split(':')[0]}}' -->
               <v-card-title
                  class="title grey--text darken-4 font-weight-bold pb-4"
               >Pick a Date and Time for '{{dateFieldName}}'
               </v-card-title>
               <v-card-text
                  class="px-4 pt-0 pb-1"                  
               >
                  <v-row class="pt-2 py-0">
                     <v-col class="py-0 px-2">                        
                        <v-date-picker reactive
                           ref="datepicker"
                           v-model="currDate"
                           @change="dateFieldChanged()"
                        ></v-date-picker>
                     </v-col>

                     <v-col class="py-0 px-2">
                        <!-- use-seconds -->
                        <v-time-picker ampm-in-title scrollable
                           v-model="currTime"
                           @click:hour="dateFieldChanged()"
                           @click:minute="dateFieldChanged()"
                           @update:period="dateFieldChanged()"
                        ></v-time-picker>
                     </v-col>
                  </v-row>
               </v-card-text>
               <v-card-actions class="pt-0 pb-2 pr-5">
                  <div class="flex-grow-1"></div>
                  <v-btn text
                     class="px-0"
                     color="blue darken-1"
                     @click="cancelDialogDate"
                  >Cancel</v-btn>
                  <v-btn text
                     class="pl-0 pr-2"
                     color="blue darken-1"
                     :disabled="dateSubmitDisabled"
                     @click="submitDialogDate"
                  >Submit</v-btn>
               </v-card-actions>
            </v-card>
         </v-form>
      </v-dialog>

      <v-dialog no-click-animation persistent scrollable
         max-width="960px"
         v-model="dialogAddEvent"
      >
         <v-form lazy-validation
            ref="addEventForm"
            v-model="isAddEventFormValid"
         >
            <v-card flat tile
               :loading="loadingAddEvent"
            >
               <v-card-title
                  class="title grey--text darken-4 font-weight-bold pb-4"
               >{{crm.title}}
               </v-card-title>

               <v-card-text 
                  class="px-5 pt-0 pb-3"                  
               >
                  <v-row>
                     <v-col class="pt-0">
                        <!-- :rules="[rules.required]"
                           :hint="crm.event_code" -->
                        <v-select dense hide-selected persistent-hint
                           autocomplete="off"
                           class="pt-0 pb-3"
                           ref="currEventCode"
                           placeholder="select an item to continue..."
                           hint="Event Code"
                           :items="crm.event_codes || []"
                           v-model="currEventCode"
                           @change="eventCodeChanged"
                        ></v-select>
                     </v-col>
                  </v-row>
                  <div v-if="currEventCode">
                     <v-row v-for="(iIndex, i) in Math.ceil(eventFields.length / numOfCols)" :key="`row_${i}`"
                        class="pt-2 pb-0 px-1" 
                     >
                        <v-col v-for="(jIndex, j) in numOfCols" :key="`col_${j}`"
                           :cols="12 / numOfCols" 
                           class="py-0 px-2" 
                        >
                           <div v-if="i * numOfCols + j < eventFields.length">
                              <!-- v-if="isSelect(i * numOfCols + j)" -->
                              <v-select v-if="eventFields[i * numOfCols + j].options"
                                 dense outlined persistent-hint
                                 autocomplete="off"
                                 class="py-0"
                                 :clearable="!eventFields[i * numOfCols + j].required"
                                 :hint="eventFields[i * numOfCols + j].hint"
                                 :items="eventFields[i * numOfCols + j].options"
                                 :label="`${eventFields[i * numOfCols + j].required ? '* ' : ''}${eventFields[i * numOfCols + j].name}`"
                                 :multiple="eventFields[i * numOfCols + j].isMultiple"
                                 :ref="`value_${i}_${j}`"
                                 :rules="eventFields[i * numOfCols + j].rules"
                                 v-model="eventFields[i * numOfCols + j].value"
                                 @click:clear="eventTextFieldCleared(i * numOfCols + j)"
                              ></v-select>
                              <v-text-field v-else-if="eventFields[i * numOfCols + j].type === 'date'"
                                 dense outlined persistent-hint readonly
                                 append-icon="mdi-calendar"
                                 autocomplete="off"
                                 class="py-0"
                                 :clearable="!eventFields[i * numOfCols + j].required"
                                 :hint="eventFields[i * numOfCols + j].value"
                                 :label="`${eventFields[i * numOfCols + j].required ? '* ' : ''}${eventFields[i * numOfCols + j].name}`"
                                 :ref="`value_${i}_${j}`"
                                 :rules="eventFields[i * numOfCols + j].rules"
                                 type="text"
                                 v-model="eventFields[i * numOfCols + j].dateValue"
                                 @click="dateFieldClicked(eventFields[i * numOfCols + j])"
                                 @click:clear="eventTextFieldCleared(i * numOfCols + j)"
                              ></v-text-field>
                              <v-text-field v-else
                                 dense outlined persistent-hint
                                 autocomplete="off"
                                 class="py-0"
                                 :clearable="!eventFields[i * numOfCols + j].required"
                                 :hint="eventFields[i * numOfCols + j].hint"
                                 :label="`${eventFields[i * numOfCols + j].required ? '* ' : ''}${eventFields[i * numOfCols + j].name}`"
                                 :min="eventFields[i * numOfCols + j].min ? eventFields[i * numOfCols + j].min : null"
                                 :max="eventFields[i * numOfCols + j].max ? eventFields[i * numOfCols + j].max : null"
                                 :ref="`value_${i}_${j}`"
                                 :rules="eventFields[i * numOfCols + j].rules"
                                 :type="eventFields[i * numOfCols + j].type === 'string' ? 'text' : eventFields[i * numOfCols + j].type"
                                 v-model="eventFields[i * numOfCols + j].value"
                                 @click:clear="eventTextFieldCleared(i * numOfCols + j)"
                              ></v-text-field>
                           </div>
                        </v-col>
                     </v-row>
                  </div>
               </v-card-text>

               <v-card-actions class="pt-0 pb-1 pr-3">
                  <div class="flex-grow-1"></div>
                  <v-btn text
                     class="px-0"
                     color="blue darken-1"
                     @click="closeDialogAddEvent"
                  >Cancel</v-btn>
                  <v-btn text
                     class="pl-0 pr-2"
                     color="blue darken-1"
                     :disabled="!currEventCode || !isAddEventFormValid"
                     @click="submitDialogAddEvent"
                  >Submit</v-btn>
               </v-card-actions>
            </v-card>
         </v-form>
      </v-dialog>

      <v-dialog no-click-animation persistent scrollable
         max-width="1200px"
         v-model="dialogUpdate"
      >
         <v-card flat tile :loading="isUpdateInProcess">
            <v-card-title class="title grey--text darken-4 font-weight-bold pb-4">Update the Results</v-card-title>
            <v-card-text class="px-5 pt-2 pb-1">
               <v-form lazy-validation
                  ref="formUpdate"
                  v-model="isFormUpdateValid"
               >
               <div class="ml-2">
                  <span v-if="isFeed">
                     To update all matched records of the filtered records, type '<span class="font-weight-bold">update</span>' in the following box.
                     <br><b>NOTE:</b> You can find out the actual number of deleted records on the <i>Tags</i> page once the process is completed.
                  </span>
                  <span v-else>
                     To update {{new Intl.NumberFormat().format(offersCount)}} filtered records, type <span class="font-weight-bold">{{offersCount}}</span> in the following box:
                  </span>
               </div>
               <v-text-field dense outlined hide-details
                  ref="numberOfOffers"
                  class="pt-2 pb-3"
                  v-model="numberOfOffers"
               ></v-text-field>
               <v-row>
                  <v-col :cols="fieldNameColSize">
                     <v-combobox v-if="jwt.pa"
                        dense hide-selected persistent-hint
                        ref="fieldName"
                        autocomplete="off"
                        hint="* Field Name"
                        placeholder="select/type a field..."
                        :items="updatableOfferFields"
                        :rules="[rules.required]"
                        v-model="updatingOfferField.name"
                        @change="updatingOfferFieldChanged"
                     ></v-combobox>
                     <v-autocomplete v-else
                        dense hide-selected persistent-hint
                        ref="fieldName"
                        autocomplete="off"
                        hint="* Field Name"
                        placeholder="select a field..."
                        :items="updatableOfferFields"
                        :rules="[rules.required]"
                        v-model="updatingOfferField.name"
                        @change="updatingOfferFieldChanged"
                     ></v-autocomplete>
                  </v-col>
                  <template v-if="updatingOfferField.name && updatingOfferField.name != 'clear_events'">
                     <template v-if="updatingOfferField.name === 'add_event'">
                        <v-col :cols="fieldNameColSize" class="px-1">
                           <v-text-field counter dense persistent-hint
                              class="py-0"
                              ref="appCode"
                              autocomplete="off"
                              :hint="`${updatingOfferField.appCode ? '* App Code' : ''}`"
                              :maxlength="3"
                              placeholder="enter an app code"
                              :rules="[rules.required, rules.length(3)]"
                              v-model="updatingOfferField.appCode"
                           ></v-text-field>
                        </v-col>
                        <v-col :cols="fieldNameColSize" class="px-1">
                           <v-text-field counter dense persistent-hint
                              class="py-0"
                              ref="eventCode"
                              autocomplete="off"
                              :hint="`${updatingOfferField.eventCode ? '* Event Code' : ''}`"
                              :maxlength="5"
                              placeholder="enter an event code"
                              :rules="[rules.required, rules.length(5)]"
                              v-model="updatingOfferField.eventCode"
                           ></v-text-field>
                        </v-col>
                        <!-- V260326: added -->
                        <v-col :cols="fieldNameColSize" class="pl-1 pr-0">
                           <v-text-field dense persistent-hint
                              class="py-0"
                              ref="eventPath"
                              autocomplete="off"
                              :hint="`${updatingOfferField.eventPath ? 'Event Path' : ''}`"
                              placeholder="optional event path"
                              v-model="updatingOfferField.eventPath"
                           ></v-text-field>
                        </v-col>
                        <!-- V260326: added -->
                        <v-col :cols="fieldNameColSize" class="px-1">
                           <v-text-field dense persistent-hint
                              class="py-0"
                              ref="eventElement"
                              autocomplete="off"
                              :hint="`${updatingOfferField.eventElement ? 'Event Element' : ''}`"
                              placeholder="optional event element"
                              v-model="updatingOfferField.eventElement"
                           ></v-text-field>
                        </v-col>
                     </template>
                     <v-col :cols="fieldNameColSize" v-else>
                        <!--V260218: :disabled="updatingOfferField.isTypeDisabled" -->
                        <v-select dense hide-selected persistent-hint
                           class="py-0"
                           ref="type"
                           autocomplete="off"
                           hint="* Field Type"
                           :items="types"
                           :rules="[rules.required]"
                           v-model="updatingOfferField.type"
                        ></v-select>
                     </v-col>
                     <v-col :cols="fieldNameColSize" v-if="updatingOfferField.type">
                        <v-select v-if="updatingOfferField.type === 'boolean'"
                           dense hide-selected persistent-hint
                           class="py-0"
                           ref="value"
                           autocomplete="off"
                           hint="* Boolean Value"
                           placeholder="select a value..."
                           :items="booleanItems"
                           :rules="[rules.requiredBoolean]"
                           v-model="updatingOfferField.value"
                        ></v-select>
                        <v-text-field v-else-if="updatingOfferField.type === 'date'"
                           dense persistent-hint readonly
                           class="py-0"
                           ref="value"
                           autocomplete="off"
                           append-icon="mdi-calendar"
                           :hint="`${updatingOfferField.dateValue ? '* Date Value' : ''}`"
                           placeholder="click to set date/time"
                           type="text"
                           :rules="[rules.required]"
                           v-model="updatingOfferField.dateValue"
                           @click="dateFieldClicked(updatingOfferField)"
                        ></v-text-field>
                        <v-text-field v-else
                           dense persistent-hint
                           class="py-0"
                           ref="value"
                           autocomplete="off"
                           :hint="updatingOfferField.type === 'number' ? '* Numeric Value' : '* String Value'"
                           placeholder="specify a value..."
                           :type="updatingOfferField.type === 'number' ? 'number' : 'text'"
                           :rules="[rules.required]"
                           v-model="updatingOfferField.value"
                        ></v-text-field>
                     </v-col>
                  </template>
               </v-row>
               <div v-if="isUpdateInProcess"
                  class="error--text font-weight-bold"
               >
                  <v-progress-circular indeterminate
                     color="red"
                     :size="20"
                     :width="2"
                  ></v-progress-circular>
                  Please wait while your request is being processed: {{updateElapsedTime}}
               </div>
               </v-form>
            </v-card-text>
            <v-card-actions class="pt-0 pb-2 pr-5">
               <div class="flex-grow-1"></div>
               <v-btn text
                  class="px-0"
                  color="blue darken-1"
                  :disabled="isUpdateInProcess"
                  @click="cancelDialogUpdate"
               >Cancel</v-btn>
               <v-btn text
                  class="px-0"
                  color="blue darken-1"
                  :disabled="!isFormUpdateValid || isUpdateInProcess || (isFeed ? numberOfOffers != 'update' : numberOfOffers != offersCount)"
                  @click="submitDialogUpdate"
               >Submit</v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

   </v-card>
</v-container>
</template>

<script>
import BtFilterWrapperWithPanel from './BtFilterWrapperWithPanel.vue';
import BtChart from './BtChart.vue';
import { APIService } from '../services/cs-api-service.js';
import { hasOwn, isIncluded, getAllBehavioralFields, isDate, isNumber, isBoolean, convertToBoolean, convertToISODate } from '../mixins/bt-mixin.js';
import { BtHelpers } from '../services/bt-helpers.js';
import { differenceInHours, differenceInMinutes, differenceInSeconds, format, parseISO } from "date-fns";

const NAME = "CsDocuments";
const VERSION = 'V260326.1';
const DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

let DEBUG;

class UpdatingOfferField {
   constructor(name) {
      this.name = name || '';
      this.text = '';
      this.type = '';
      this.isTypeDisabled = false;
      this.dateValue = '';
      this.value = '';
      this.appCode = '';
      this.eventCode = '';
      // V260326: added
      this.eventPath = '';
      this.eventElement = '';
   }
}

// function _alert(msg) {
//    if (DEBUG) {
//       console.log(`-----${NAME} ${VERSION} says => ${msg}`);
//       alert(`-----${NAME} ${VERSION} says-----\n${msg}`);
//    }
// }

function _log(msg) {
   if (DEBUG) {
      console.log(`-----${NAME} ${VERSION} says => ${msg}`);
   }
}

function _getElapsedTime(dateStarted) {
   const dateEnded = new Date();
   const h = differenceInHours(dateEnded, dateStarted);
   const min = differenceInMinutes(dateEnded, dateStarted);
   const m = min - h * 60;
   const s = differenceInSeconds(dateEnded, dateStarted) - h * 3600 - m * 60;
   let elapsedTime = '';
   if (h) elapsedTime = h + 'h ';
   if (min) elapsedTime += m + 'm ';
   elapsedTime += s + 's';
   return elapsedTime;
}

export default {
   name: NAME,

   components: {
      BtFilterWrapperWithPanel,
      BtChart
   },

   props: {
      debug: {
         type: Boolean,
         default: false
      },

      isActualEndpoint: {
         type: Boolean,
         default: true
      }
   },

   data() {
      return {
         panelFilter: [],  //[0]
         limit: 5,
         rules: {
            required: value => !!value || "Value is required!",
            requiredArray: value => !!value && !!value.length || "Value is required!",
            requiredBoolean: value => value === true || value === false || "Value is required!",
            minLength(eventField) {
               return value => {
                  if (value)
                     return value >= eventField.min || `Value should be greater than or equal to ${eventField.min}!`;
                  else
                     return true;
               }
            },
            maxLength(eventField) {
               return value => {
                  if (value)
                     return value <= eventField.max || `Value should be less than or equal to ${eventField.max}!`;
                  else
                     return true;
               }
            },
            custom(eventField) {
               // alert('in custom(): eventField=' + JSON.stringify(eventField));
               return value => {
                  if (value) {
                     const regex = new RegExp(eventField.regex, 'i');
                     return regex.test(value) || "Value is invalid!";
                  } else
                     return true;
               }
            },
            length(len) {
               return value => {
                  return value.trim().length === len || `Value should have ${len} chars!`;
               }
            }
         },
         jwt: {},
         apiService: null,
         btHelpers: null,
         loadingOffers: true, //false,
         importHeaders: [],
         offers: [],
         search: "",
         offerHeaders: [],
         selectedHeaders: [],
         isOfferHeadersNeeded: true,
         shouldInitFilterDefiner: false,
         colspans:[],
         offersCount: 0,
         options: {
               // page: number,
               // itemsPerPage: number,
               // sortBy: string[],
               // sortDesc: boolean[],
               // groupBy: string[],
               // groupDesc: boolean[],
               // multiSort: boolean,
               // mustSort: boolean
         },
         lastImport: null,
         stdFieldValues: {},
         chart: {
            title: '',
            type: 'ColumnChart',
            options: {
               "legend": { "position": "top" }
            },
            filter: {}
         },
         itemKey: '_id',
         filter: {},
         behFields: null,
         behFieldsForGroupby: null,
         dialogEvents: false,
         loadingEvents: false,
         eventHeaders: [],
         events: [],
         expanded: [],
         loadingDeleteBtn: false,
         isAnotherDelete: false,
         dialogDelete: false,
         numberOfOffers: '',
         isDeleteInProcess: false,
         deleteElapsedTime: '',
         initialFilter: {},
         dialogEdit: false,
         loadingDialogEdit: null,   //boolean
         editedOffer: null,   //object
         currOffer: null,   //object
         // isDialogEditDirty: null,   //boolean
         booleanItems: [
            { text: 'true', value: true },
            { text: 'false', value: false }
         ],
         numOfChanges: null,  //numeric
         isFormEditValid: true,
         action: null,  //add|edit
         panelsEdit: [0],
         isFormDateValid: true,
         dialogDate: false,
         // currFieldName: null,
         currDateField: null,
         currDate: null,
         currTime: null,
         dateSubmitDisabled: null,
         expandedItem: [],
         /***** For Add Event *****/
         crm: {},
         dialogAddEvent: false,
         isAddEventFormValid: null, //boolean
         loadingAddEvent: false,
         currEventCode: '',
         eventFields: [],
         numOfCols: 3,
         deletesCount: 0,
         deletesFilter: null,
         isFeed: false,
         footerProps: {
            itemsPerPageOptions:[5, 10, 20],
            // showFirstLastPage: false
            // showFirstLastPage: offersCount <= 100000  //V240104.1
         },
         closedOnLoad: true,
         collectionInfo: {},
         fields: [],  //V240828
         //for Updates btn
         offerFields: [],
         offerFieldsTypeCasting: null,
         updatableOfferFields: [],
         updatingOfferField: new UpdatingOfferField(),
         loadingUpdateBtn: false,
         dialogUpdate: false,
         isUpdateInProcess: false,
         updateElapsedTime: '',
         types: [],
         isFormUpdateValid: true
      }
   },

   computed: {
      token() {
         return this.$store.getters.token;
      },

      canAddEvent() {
         return this.$store.getters.user.policies.includes('contact-event-add');
      },

      canAddOffer() {
         return this.canAddEvent && this.$store.getters.user.policies.includes('contact-offers-create');
            // && this.$store.getters.user.policies.includes('contact-event-add');
      },

      canEditOffer() {
         return this.canAddEvent && this.$store.getters.user.policies.includes('contact-offers-update');
            // && this.$store.getters.user.policies.includes('contact-event-add');
      },

      showGroupbyTable() {
         // return this.filter.columns && this.filter.columns.length === 0;
         return this.filter.standard && this.filter.standard.find(item => item["$group"]);
      },

      showChart() {
         //no chart for distinct query
         // _alert('showGroupbyTable=' + this.showGroupbyTable +
         //    '\noffers=' + this.offers);
         // if (this.offers && this.offers.length > 0)
         //    _alert('showGroupbyTable=' + this.showGroupbyTable +
         //       '\noffers=' + this.offers + '\nlen=' + this.offers.length +
         //       '\nkeys=' + JSON.stringify(Object.keys(this.offers[0])));
         return this.showGroupbyTable && 
            this.offers && 
            this.offers.length > 0 && 
            Object.keys(this.offers[0]).length > 2;   //2 is because of the index key
      },

      dialogEditTitle() {
         if (this.action === 'add')
            return `Add a New Document with ${this.currOffer.editable.length} Fields`;
         else if (this.action === 'edit')
            return `Edit Document with ${this.currOffer.editable.length + this.currOffer.empty.length} Fields`;
         else
            return '';
      },

      dateFieldName() {
         if (this.currDateField) {
            if (this.currDateField.name === 'add_event')
               return 'event_date';
            else
               return (this.currDateField.text || this.currDateField.name).replace('* ').split(':')[0];
         } else
            return '';
      },

      mfiStudioSyncVal() {
         return this.filter.standard[0].$match._mfi_studio_sync;
      },

      isDeleteBtnDisabled() {
         return typeof this.mfiStudioSyncVal === 'boolean';
      },

      includedTabs() {
         if (this.isFeed)
            return ['standard', 'columns'];
         else
            return ['standard', 'behavioral', 'bylocation', 'groupby', 'columns', 'predefined', 'fulltext'];
      },

      expansionPanelHeader() {
         return this.isFeed ? 'FEED FILTERS' : 'FILTERS';
      },

      //V240903
      operators() {
         if (this.isFeed)
            return [   
               { text: "Equals (=)", value: "=" },
               { text: "Not Equals (!=)", value: "!=" },
               // { text: "Contains", value: "contains" },
               // { text: "Starts with", value: "starts" },
               // { text: "Ends with", value: "ends" },
               { text: "Greater than (>)", value: ">" },
               { text: "Greater than or equal (>=)", value: ">=" },
               { text: "Less than (<)", value: "<" },
               { text: "Less than or equal (<=)", value: "<=" },
               { text: "In", value: "in" },
               { text: "Not in", value: "nin" },
               // { text: "Regex", value: "regex" },
               { text: "Between", value: "between" }
            ];
         else
            return undefined;
      },

      fieldNameColSize() {
         if (!this.updatingOfferField.name || this.updatingOfferField.name === 'clear_events')
            return 12;
         else if (this.updatingOfferField.name === 'add_event')
            return 2;
         else return 4;
      }

      // isUpdateBtnDisabled() {
      //    return typeof this.mfiStudioSyncVal === 'boolean';
      // },
   },

   watch: {
      token() {
         this.init();
      },

      options: {
         async handler (val) {
            if (val && val.sortBy && val.sortBy.length) {
               const sort = {};
               sort[val.sortBy[0]] = val.sortDesc[0] ? -1 : 1;
               this.filter.sort = sort;
            }

            await this.getOffers();

            //We will get the previous offers again if no more offers available.
            //This will only happen if the number of records are a factor of itemsPerPage.
            if (this.isFeed && val && val.page > 1 && !this.offers.length) {
               val.page--;
               this.getOffers();
            }
         }
      }
   },

   methods: {
      logout() {
         this.$router.push('/');
      },

      async init() {
         // _alert('in init(): token=' + this.token);
         this.importHeaders = [];

         if (this.token) {
            this.loadingOffers = true;
            this.jwt = JSON.parse(Buffer.from(this.token.split('.')[1], 'base64'));
            // _log('in init(): jwt=' + JSON.stringify(this.jwt));
            this.apiService = new APIService(this.jwt, this.token, this.debug, this.isActualEndpoint);
            this.btHelpers = new BtHelpers(this.token, this.isActualEndpoint, this.debug);

            this.filter = this.btHelpers.getInitialFilter();   //columns will be added later on

            this.stdFieldValues = await this.btHelpers.getFieldValues(this.filter, true);
            this.importHeaders = await this.btHelpers.getImportHeaders(this.filter, true, true);
            // alert('in init(): importHeaders=' + JSON.stringify(this.importHeaders));

            if (this.importHeaders.length > 0) {
               this.selectedHeaders = await this.btHelpers.getSelectedHeaders(this.importHeaders, 7);
               this.getFields();
            } else {
               this.selectedHeaders = [];
               this.fields = [];
               alert("Sorry, something went wrong and we couldn't obtain your import headers!");
            }

            this.filter.columns = [...this.selectedHeaders];

            //B1.22
            // this.filter.standard[0].$match.importId = this.stdFieldValues.importId[0].value;
            //B1.27
            if (this.stdFieldValues.importId.length)  //V221107.2
               this.filter.standard[0].$match.importId = {
                  '$in': [this.stdFieldValues.importId[0].value]
               };
            // _alert('filter=' + JSON.stringify(this.filter));
            this.initialFilter.standard = ['importId'];

            await this.filterChanged(this.filter, true);
            await this.getSettings();
            await this.getCollectionInfo();
            this.shouldInitFilterDefiner = true;
            this.loadingOffers = false;

            // if (!this.isActualEndpoint)
            //    this.initialFilterForTesting();
         } else
            this.jwt = {};
      },

      async getCollectionInfo() {
         let result = await this.apiService.getCollectionInfo();
         if (result.logout)
            this.logout();
         this.collectionInfo = result.data;
      },

      initialFilterForTesting() {
         this.filter = {
            "standard":[
               {
                  "$match": {
                     "importId": {"$in": [122]},
                     "purlNumber": { "$gte": 5, "$lt": 115 },
                     "transaction_date": {
                        "$gte": "2024-01-01T00:00:00.000Z",
                        "$lt": "2024-01-10T00:00:00.000Z"
                        },
                     "events": {
                        "$elemMatch": {
                           "event_date": {
                              "$gte": "2024-01-04T00:00:00.000Z",
                              "$lt": "2024-01-11T00:00:00.000Z"
                           },
                           "event_data.__program": {
                              "$gte": 0,
                              "$lt": 1
                           }
                        }
                     }
                  }
               },
               {
                  "$project": {
                     "events": {
                        "$filter": {
                           "input": "$events",
                           "as": "event",
                           "cond": {
                              "$and": [
                                 {
                                    "$gte": [
                                       "$$event.event_date",
                                       "2024-01-10T00:00:00.000Z"
                                    ]
                                 },
                                 {
                                    "$gte": [
                                       "$$event.event_data.__program",
                                       0
                                    ]
                                 }
                              ]
                           }
                        }
                     }
                  }
               }


               // {"$match":{}},
               // {"$project":{"events":1}},
               // {"$unwind":"$events"},
               // {
               //    "$group":{
               //       "_id":{"Event Code":"$events.event_code","Program":"$events.event_data.__program"},
               //       // "_id":{"Program":"$events.event_data.__program","Event Code":"$events.event_code"},
               //       "Count":{"$sum":1}
               //    }
               // },
               // {"$sort":{"Count":-1}},
               // {"$limit":50}


               // "$match": {
               //    "importId": {"$in": ["1","2"]},
               //    "product": "Product3",
               //    "_mfi_studio_sync": true,
               //    "_mfi_studio_added_record": {"$exists": false}
               // }
            ],
            // "columns":[]
         };
      },

      async filterChanged(filter, addDate) {
         _log('in filterChanged(): filter=' + JSON.stringify(filter) + ', addDate=' + addDate);
         this.filter = filter;
         if (this.importHeaders.length > 0) {
            //V250924: const date = addDate ? convertToISODate(new Date(), true) : null;

            //V231220 - start
            //this.offersCount = await this.getOffersCount(filter, date);
            if (this.isFeed) {
               this.feedsCount = 0;
               this.footerProps.showFirstLastPage = false;
            } else {
               const $match = filter.standard.find(f => f.$match).$match;
               if (Object.keys($match).length === 1 && $match.importId) {
                  let count = 0;
                  $match.importId.$in.forEach(id => {
                     count += this.stdFieldValues.importId.find(item => item.value === id).availableRecords;
                  });
                  this.offersCount = count;
               } else {
                  //V250924: this.offersCount = await this.getOffersCount(filter, date);
                  this.offersCount = await this.getOffersCount(filter, addDate);
               }
               
               this.footerProps.showFirstLastPage = this.offersCount <= 100000  //V240104.1
            }
            //V231220 - end

            this.isOfferHeadersNeeded = true;

            this.selectedHeaders = [...filter.columns];

            const len = filter.columns.length + 1;
            this.colspans = [];
            this.colspans.push(Math.ceil(len / 3));
            this.colspans.push(Math.ceil((len - this.colspans[0]) / 2));
            this.colspans.push(len - this.colspans[0] - this.colspans[1]);

            const currOptions = JSON.stringify(this.options);
            const newOptions = JSON.parse(currOptions);
            newOptions.page = 1;
            if (filter.sort) {
               // this.isDataCurrent = true;
               const key = Object.keys(filter.sort)[0];
               newOptions.sortBy = [key];
               newOptions.sortDesc = [filter.sort[key] === -1];
               // _alert('options=' + JSON.stringify(this.options))
            }
            
            if (JSON.stringify(newOptions) === currOptions) {
               //V250924: await this.getOffers(date);
               await this.getOffers(true);
            } else
               this.options = newOptions;
         }

         // _alert('filter.standard.length=' + filter.standard.length +
         //    '\nfilter=' + JSON.stringify(filter));

         // was modified in B1.1
         // if (filter.standard.length > 1) {
         //    this.chart = {
         //       title: '',
         //       type: 'ColumnChart',
         //       options: {},
         //       filter: filter
         //    };
         // } else {
         //    this.chart = {
         //       title: '',
         //       type: '',
         //       options: {},
         //       filter: {}
         //    };
         // }

         if (!this.isFeed)
            this.chart.filter = filter;
      },

      async getOffersCount(offersFilter, addDate) {
         const date = addDate ? convertToISODate(new Date(), true) : null;
         let result = await this.apiService.getOffersCount(offersFilter, date);
         if (result.logout)
            this.logout();
         return result.message ? 0 : result.data;
      },

      async getOffers(addDate) { //V250924: date
         _log('in getOffers: filter=' + JSON.stringify(this.filter.columns) + '\naddDate=' + addDate);
         this.offers = [];
         // if (!Object.keys(this.filter).length || !this.filter.columns || !this.filter.columns.length || !this.offersCount)
         //    return;

         let condition = !Object.keys(this.filter).length || !this.filter.columns || !this.filter.columns.length;
         condition = this.isFeed ? condition : condition || !this.offersCount;
         if (condition) return;

         // _alert('in getOffers()...\n' + JSON.stringify(this.filter));
         this.loadingOffers = true;
         // const { sortBy, sortDesc, page, itemsPerPage } = this.options
         const date = addDate ? convertToISODate(new Date(), true) : null;
         let result = await this.apiService.getOffers(this.filter, this.options.page, this.options.itemsPerPage, date);
         if (result.logout)
            this.logout();
         else if (result.data && result.data.length) {
            result.data.forEach(offer => {
               for (const key in offer) {
                  // const val = offer[key].toString().toLowerCase();
                  const val = offer[key] ? offer[key].toString().toLowerCase() : '';
                  if (val === 'true' || val === 'false')
                     offer[key] = offer[key].toString();
               }
            });

            if (this.isOfferHeadersNeeded) {
               this.offerHeaders = [];
               const group = this.filter.standard.filter(f => f.$group);
               if (group.length === 1) {
                  const _id = group[0].$group._id;
                  let id, idFieldText, idFieldType;
                  let idFieldPostfix;
                  if (typeof _id === 'object') {
                     Object.keys(_id).forEach(key => {
                        idFieldPostfix = ' / ';
                        const val = _id[key];
                        // _alert('key=' + key + ', val=' + JSON.stringify(val));
                        if (typeof val === 'object') {
                           id = val['$' + key].replace('$events.', '').replace('$', '');
                           // _alert('if val object: id=' + id);
                           let idField = this.importHeaders.find(f => f.value === id);
                           if (!idField)
                              idField = this.behFieldsForGroupby.find(f => f.value === id);

                           idFieldText = idField.text;
                           idFieldType = idField.type;
                        } else {
                           // id = _id[key];
                           // _alert('else val object: id=' + id);
                           idFieldText = key;
                           idFieldType = '';
                        }

                        switch (key) {
                           case 'year':
                              idFieldPostfix += 'Yearly'
                              break;
                           case 'month':
                              idFieldPostfix += 'Monthly'
                              break;
                           case 'dayOfMonth':
                              idFieldPostfix += 'Daily'
                              break;
                           case 'hour':
                              idFieldPostfix += 'Hourly'
                              break;
                           case 'dayOfWeek':
                              idFieldPostfix += 'Day of the Week'
                              break;
                           default:
                              idFieldPostfix = '';
                              break;
                        }

                        this.offerHeaders.push({ 
                           text: idFieldText + idFieldPostfix, 
                           value: '_id' + (idFieldType === 'date' ? '' : '.' + idFieldText)
                        });
                     });
                  } else {
                     // id = _id.replace('$', '');
                     // _alert('_id=' + _id + ', id=' + id);
                     idFieldPostfix = '';
                  }

                  for (let i = 1; i < Object.keys(result.data[0]).length; i++) {
                     const element = Object.keys(result.data[0])[i];
                     this.offerHeaders.push({ text: element, value: element });
                  }
               } else {
                  this.offerHeaders = this.importHeaders.filter(header => isIncluded(this.selectedHeaders, header.value, true));
                  this.filter.columns.forEach(col => {
                     if (!this.offerHeaders.find(h => h.value === col))
                        this.offerHeaders.push({ text: col, value: col, isIndexed: false, isSortable: false });
                  });
                  this.offerHeaders.push({ text: 'Actions', value: 'actions', align: 'right', sortable: false, width: "10%" });
               }

               this.offerHeaders.forEach(header => {
                  header.sortable = header.isIndexed;
               });

               this.isOfferHeadersNeeded = false;
               // _alert('in getOffers(): offerHeaders=' + JSON.stringify(this.offerHeaders));
            }

            if (this.filter.standard.length > 1) {
               this.itemKey = 'index';
               result.data.forEach((d, i) => {
                  d.index = i;
               });
               this.offers = [...result.data];
            } else {
               this.itemKey = '_id';
               this.offers = result.data;
            }

            if (!this.showGroupbyTable) {
               this.offers.forEach(element => {
                  Object.keys(element).forEach(key => {
                     if (typeof element[key] === 'boolean')
                        element[key] = element[key].toString();
                  });
               });
            }
         }

         if (this.isFeed && !this.feedsCount) {
            this.offersCount = (this.options.page -1 ) * this.options.itemsPerPage + this.offers.length;
            if (this.offers.length === this.options.itemsPerPage)
               this.offersCount++;
            else {
               this.feedsCount = this.offersCount;
            }
         }

         this.loadingOffers = false;
         _log('in getOffers(): offers=' + JSON.stringify(this.offers));
      },

      async offerExpanded(offer, addDate) {
         // _alert('in offerExpanded(): offer=' + JSON.stringify(offer));
         if (offer.length === 0 || offer[0].details) return;

         this.loadingOffers = true;
         const date = addDate ? convertToISODate(new Date(), true) : null;
         let result = await this.apiService.getOffer(offer[0]._id, date);
         if (result.logout)
            this.logout();
         else if (!result.message) {
            offer[0].details = [[], [], []];
            let seq= 0;
            offer[0].originalDetails = result.data;
            for (const key in result.data) {
               offer[0].details[seq++].push({
                  key: key,
                  value: result.data[key]
               });
               if (seq === 3) seq = 0;
            }
         }
         this.loadingOffers = false;
         _log('in offerExpanded(): offer=' + JSON.stringify(offer[0].details));
      },

      getIdValue(value) {
         // _alert('value=' + JSON.stringify(value) + '\n' + Object.keys(value)[0]);
         if (typeof value === 'object') {
            const key = Object.keys(value)[0];
            if (key === 'dayOfWeek')
               return DAYS[value[key] - 1];
            else if (key === 'month')
               return MONTHS[value[key] - 1];
            else
               return value[key];
         } else
            return value;
      },

      formatNumber(number, maxFractionDigits) {
         return new Intl.NumberFormat('en-US', 
            { 
               maximumFractionDigits: maxFractionDigits
            }).format(number);
      },

      eventsClicked(events) {
         // _alert('in eventsClicked(): events=' + JSON.stringify(events));
         this.dialogEvents = true;
         this.loadingEvents = true;
         const headers = [];
         const mainHeaders = new Set();
         const subHeaders = new Set();

         events.forEach((event, i) => {
            Object.keys(event).forEach(key => {
               if (this.behFields.find(f => f.value != 'event_data' && f.value === key.toString()))
                  mainHeaders.add(key);
               else if (key.toString() != '__csDocumentsExtras')
                  subHeaders.add(key);
            });
            event.__csDocumentsExtras = { id: `${event.event_code}_${event.event_date}_${i}` };
         });

         // _alert('mainHeaders.size=' + mainHeaders.size + ', subHeaders.size=' + subHeaders.size);
         // _alert('mainHeaders=' + JSON.stringify(mainHeaders) + ', subHeaders=' + JSON.stringify(subHeaders));

         mainHeaders.forEach(h => {
            /* B1.24
            let text;
            switch (h) {
               case 'app_code':
                  text = 'App Code';
                  break;
               case 'event_code':
                  text = 'Event Code';
                  break;
               case 'event_date':
                  text = 'Event Date';
                  break;
               case 'is_trigger':
                  text = 'Is Trigger';
                  break;
               case 'os':
                  text = 'Operating System';
                  break;
               case 'browser':
                  text = 'Browser';
                  break;
               case 'ip':
                  text = 'IP';
                  break;
               case 'pdid':
                  text = 'Process Definition ID';
                  break;
               default:
                  break;
            }

            if (text)
               headers.push({ text: text, value: h, align: 'left', sortable: true });
            */

            const behField = this.behFields.find(f => f.value === h);
            if (behField)
               headers.push({ text: behField.text, value: h, align: 'left', sortable: true });
         });

         this.events = [...events];
         this.eventHeaders = [...headers];
         this.eventDetailHeaders = Array.from(subHeaders);
         this.loadingEvents = false;
      },

      eventExpanded(event) {
         // _alert('in eventExpanded(): event=' + JSON.stringify(event));
         if (event.length === 0) return;

         const e = event[0];
         e.__csDocumentsExtras.details = [];
         this.eventDetailHeaders.forEach(h => {
            if (e[h])
               e.__csDocumentsExtras.details.push({ key: h, value: e[h] });
         });
         // _alert('in eventExpanded(): e=' + JSON.stringify(e));
      },

      closeDialogEvents() {
         this.expanded = [];
         this.dialogEvents = false;
      },

      async deleteResultsClicked() {
         this.loadingDeleteBtn = true;
         this.isAnotherDelete = false;
         const filter = this.btHelpers.getInitialFilter();
         filter.standard[0].$match.status = 'processing';
         let result = await this.apiService.getDeletesCount(filter);
         this.loadingDeleteBtn = false;
         if (result.logout)
            this.logout();
         else if (!result.message) {
            if (result.data)
               this.isAnotherDelete = true;
            else {
               this.numberOfOffers = '';

               //This is because the synced/converted contacts cannot be deleted.
               this.deletesFilter = JSON.parse(JSON.stringify(this.filter));
               this.deletesCount = this.offersCount;
               if (typeof this.mfiStudioSyncVal === 'undefined') {
                  this.deletesFilter.standard[0].$match._mfi_studio_sync = { $exists: false };
                  if (!this.isFeed) { //V240214.4
                     //V250924: this.deletesCount = await this.getOffersCount(this.deletesFilter, convertToISODate(new Date(), true));
                     this.deletesCount = await this.getOffersCount(this.deletesFilter, true);
                  }
               }

               this.dialogDelete = true;
               setTimeout(() => {
                  this.$refs.numberOfOffers.focus();
               }, 100);
            }
         }
      },

      cancelDialogDelete() {
         this.dialogDelete = false;
      },

      async submitDialogDelete() {
         this.isDeleteInProcess = true;
         const dateStarted = new Date();
         const setIntervalDeletes = setInterval(() => {
            if (this.isDeleteInProcess) {
               // const DateEnded = new Date();
               // const h = differenceInHours(DateEnded, dateStarted);
               // const min = differenceInMinutes(DateEnded, dateStarted);
               // const m = min - h * 60;
               // const s = differenceInSeconds(DateEnded, dateStarted) - h * 3600 - m * 60;
               // this.deleteElapsedTime = '';
               // if (h) this.deleteElapsedTime = h + 'h ';
               // if (min) this.deleteElapsedTime += m + 'm ';
               // this.deleteElapsedTime += s + 's';
               this.deleteElapsedTime = _getElapsedTime(dateStarted);
            }
            else {
               clearInterval(setIntervalDeletes);
            }
         }, 1000);

         //V240214.3: let result = await this.apiService.deleteOffers(this.filter, this.numberOfOffers);
         let result = await this.apiService.deleteOffers(this.deletesFilter, this.isFeed ? 0 : this.numberOfOffers);
         this.isDeleteInProcess = false;
         if (result.logout)
            this.logout();
         else if (!result.message) {
            //V250924: this.$emit('snackbar-event', `'${result.data}' records were deleted.`);
            this.$emit('snackbar-event', 'Your DELETE request was submitted successfully. You can view its status on the Deletes page.');
            this.cancelDialogDelete();
            //V250924: this.filterChanged(this.filter, true);
         }
      },

      /********** Add & Edit Offer **********/

      async newOfferClicked() {
         if (!this.lastImport) {
            this.lastImport = await this.btHelpers.getLastImport();
            if (!this.lastImport) {
               alert("Sorry, something went wrong and we couldn't obtain the last import record!");
               return;
            }
         }

         this.currOffer = {
            editable: []
         };
         let seq = 1;
         //V230202.1
         this.importHeaders.filter(h => !h.internalField && !h.systemField).forEach(header => {
            const newItem = {
               key: header.value,
               value: null,
               text: header.text,
               seq: seq++
            };

            if (header.type)
               newItem.type = header.type;

            if (this.lastImport.generatePURL) {
               newItem.isPurl = this.lastImport.purlColumns.includes(header.value);
               newItem.isDedup = this.lastImport.dedupColumns.includes(header.value);
               newItem.required = newItem.isPurl || newItem.isDedup;
               this.buildText(newItem);
            }
            this.currOffer.editable.push(newItem);
         });

         // this.sortCurrOffer(this.currOffer.editable);

         this.numOfChanges = 0;
         this.action = 'add';
         this.dialogEdit = true;
         setTimeout(() => {
            this.$refs['formEdit'].validate();
            this.$refs['value_0_0'][0].focus();
         }, 10);
      },

      async editClicked(item) {
         // _log(`in editClicked(): item=${JSON.stringify(item)}`);
         // _alert(`in editClicked(): importHeaders=${JSON.stringify(this.importHeaders)}`);

         this.loadingOffers = true;
         this.currOffer = {
            editable: [],
            empty: [],
            static: []
         };
         const offer = [item];

         await this.offerExpanded(offer); //to get offer's details
         this.editedOffer = offer[0];

         if (!this.lastImport)
            this.lastImport = await this.btHelpers.getLastImport();

         for (const key in this.editedOffer.originalDetails) {
            if (key != 'events') {
               const header = this.importHeaders.find(h => h.value === key);
               //V230202.1: const internalField = ['_id', 'dedupHash', 'rowNumber', '__v', 'addedByUI', '_mfi_studio_sync'].includes(key) || (header && header.internalField) ? true : false;
               const internalField = ['_id', 'dedupHash', 'rowNumber', '__v', 'addedByUI'].includes(key) || (header && (header.internalField || header.systemField)) ? true : false;
               const newItem = {
                  key: key,
                  value: this.editedOffer.originalDetails[key],
                  text: header ? header.text : key,
                  required: true
               };

               if (internalField) {
                  newItem.seq = this.currOffer.static.length + 1;
                  this.currOffer.static.push(newItem);
               } else {
                  newItem.seq = this.currOffer.editable.length + 1;
                  if (header && header.type)
                     newItem.type = header.type;

                  if (this.lastImport.generatePURL) {
                     newItem.isPurl = this.lastImport.purlColumns.includes(key);
                     newItem.isDedup = this.lastImport.dedupColumns.includes(key);
                     this.buildText(newItem);
                  }
                  if (newItem.type === 'date')
                     newItem.dateValue = this.formatDate(newItem.value);
                  this.currOffer.editable.push(newItem);
               }
            }
         }

         const processedFields = [...this.currOffer.editable, ...this.currOffer.static];
         const remainingFields = this.importHeaders.filter(h => !h.internalField && !h.systemField && !processedFields.map(f => f.key).includes(h.value));
         remainingFields.forEach(element => {
            const newItem = {
               key: element.value,
               value: '',
               text: element.text,
               seq: this.currOffer.empty.length + 1,
               // type: element.type ? element.type : 'string'
            };

            if (element.type)
               newItem.type = element.type;

            this.buildText(newItem);
            this.currOffer.empty.push(newItem);
         });

         // this.sortCurrOffer(this.currOffer.editable);
         this.loadingOffers = false;
         this.numOfChanges = 0;
         this.action = 'edit';
         this.dialogEdit = true;
      },

      buildText(item) {
         const arrPostfix = [];
         if (item.isDedup) arrPostfix.push('DEDUP');
         if (item.isPurl) arrPostfix.push('PURL');
         if (arrPostfix.length)
            item.text = `* ${item.text} (${arrPostfix.join('&')})`;
         // item.text += ': ' + item.type;
         if (item.type)
            item.text += ': ' + item.type;
      },

      //not in use
      // sortCurrOffer(arrFields) {
      //    // arrFields
      //    //    .sort((o1, o2) => {
      //    //       return o2.isPurl ? 1 : -1;
      //    //    })
      //    //    .sort((o1, o2) => {
      //    //       return o2.isDedup ? 1 : -1;
      //    //    });
      // },

      //not in use
      // getTextFieldRules(i, j) {
      //    // _alert('in getTextFieldRules(): i=' + i + ', j=' + j);
      //    const rules = [];
      //    const item = this.currOffer.editable[i * 3 + j];

      //    if (item.isPurl || item.isDedup)
      //       rules.push(this.rules.required);

      //    return rules;
      // },

      formatDate(date, ignoreTime) {
         if (date) {
            // _alert('in formatDate(): date='+date+'\nwithTime=' + withTime + '\nparseISO='+parseISO(date));
            const formattedDate = format(parseISO(date), 'M/d/yyyy h:mm a');
            return ignoreTime ? formattedDate.split(' ')[0] : formattedDate;
         }
      },

      textFieldCleared(category, row, col) {
         if (this.currOffer[category][row * 3 + col].type === 'date')
            this.currOffer[category][row * 3 + col].value = '';
         this.textFieldChanged(category, row, col, '');
      },

      textFieldChanged(category, row, col, originalVal) {
         // alert(`in textFieldChanged(): category=${category}, row=${row}, col=${col}, originalVal=${originalVal}*`);
         const ooInd = row * 3 + col;
         const type = this.currOffer[category][ooInd].type;
         const val = type && type != 'string' ? originalVal : originalVal.trim();

         if (this.action === 'add')
            this.currOffer[category][ooInd].changed = val != '';
         else {
            const detail = this.editedOffer.details.flat().find(d => d.key === this.currOffer[category][ooInd].key);
            this.currOffer[category][ooInd].changed = detail ? detail.value != val : val != '';
         }

         this.getNumOfChanged();
      },

      getNumOfChanged() {
         this.numOfChanges = [...this.currOffer.editable, ...(this.action === 'edit' ? this.currOffer.empty : [])].filter(o => o.changed).length;
      },

      dateFieldClicked(dateField) {
         // alert('in dateFieldClicked(): dateField=' + JSON.stringify(dateField));
         this.currDateField = dateField
         if (dateField.value)
            this.dateSubmitDisabled = true;
         else {
            dateField.value = convertToISODate(new Date());
            this.dateSubmitDisabled = false;
         }

         this.currDate = format(parseISO(dateField.value), 'yyyy-MM-dd');
         this.currTime = format(parseISO(dateField.value), 'H:mm');

         this.dialogDate = true;
      },

      dateFieldChanged() {
         this.dateSubmitDisabled = !this.currDate || !this.currTime;
      },

      submitDialogDate() {
         // _alert(this.currDate + '\n' + this.currTime);
         const dateParts = this.currDate.split('-');
         const timeParts = this.currTime.split(':');
         const newDate = new Date(
            dateParts[0],
            dateParts[1] - 1,
            dateParts[2],
            timeParts[0],
            timeParts[1]
         );
         // // let currField = this.currOffer[this.currDateField.category][this.currDateField.index];
         // // currField.value = convertToISODate(newDate);
         // // currField.dateValue = this.formatDate(currField.value);
         // // currField.changed = true;
         this.currDateField.value = convertToISODate(newDate);
         this.currDateField.dateValue = this.formatDate(this.currDateField.value);
         this.currDateField.changed = true;
         this.cancelDialogDate();
         //V240927.1: Added this.dialogEdit condition for the sake of dialogUpdate
         if (this.dialogEdit && !this.eventFields.length)
            this.getNumOfChanged();
      },

      cancelDialogDate() {
         this.dialogDate = false;
      },

      async submitDialogEdit() {
         this.loadingDialogEdit = true;
         const modifiedFields = {};
         const fieldsToBeProcessed = [...this.currOffer.editable, ...(this.action === 'edit' ? this.currOffer.empty : [])].filter(o => o.changed);
         // _alert('in submitDialogEdit(): fieldsToBeProcessed=' + JSON.stringify(fieldsToBeProcessed));
         fieldsToBeProcessed.forEach(o => {
            let castVal;

            /* V240826 - start */
            // if (this.lastImport.typeCasting) {
            //    if (o.type === 'number') {
            //       //V240822
            //       // castVal = +o.value;
            //       castVal = o.value.length <= 16 ? +o.value : o.value;
            //    } else if (!o.type) {
            //       //V240822: following if
            //       if (o.value > 16)
            //          castVal = o.value;
            //       else if (isNumber(o.value))
            //          castVal = +o.value;
            //       else if (isBoolean(o.value))
            //          castVal = convertToBoolean(o.value);
            //       else if (isDate(o.value))
            //          castVal = convertToISODate(new Date(o.value.trim()));
            //    }
            // } 

            // V240827
            // // if (o.type === 'number')
            // //    castVal = o.value.length > 16 ? o.value : +o.value;
            // // else if (!o.type) {

               if (isNumber(o.value)) {
                  castVal = o.value.length > 16 ? o.value : +o.value;
               } else if (this.lastImport.typeCasting) {
                  if (isBoolean(o.value))
                     castVal = convertToBoolean(o.value);
                  else if (isDate(o.value))
                     castVal = convertToISODate(new Date(o.value.trim()));
               }
            
            // // }
            /* V240826 - end */

            modifiedFields[o.key] = castVal === undefined ? o.value : castVal;
         });

         // alert('in submitDialogEdit(): modifiedFields=' + JSON.stringify(modifiedFields));

         const event = {
            app_code: 'portal',
            event_code: this.action === 'add' ? 'record-add' : 'record-update',
            event_date: convertToISODate(new Date(), true),
            event_data: {
               ...modifiedFields,
               user: this.jwt.email
            }
         };

         let result;
         if (this.action === 'add') {
            modifiedFields.addedByUI = true;
            if (!this.isActualEndpoint)
               modifiedFields.events = [event];
            result = await this.apiService.createOffer(
               this.filter.standard[0].$match.importId.$in[0],
               modifiedFields
            );
         } else {
            let purl;
            const updateData = { ...modifiedFields };
            if (this.isActualEndpoint) {
               if (this.lastImport.generatePURL)
                  purl = this.currOffer.static.find(o => o.key === 'purl').value;
            } else {
               const eventsObj = this.editedOffer.details.flat().find(d => d.key === 'events');
               // console.error('eventsObj=' + JSON.stringify(eventsObj));
               if (eventsObj)
                  updateData.events = [...eventsObj.value, event];
               else
                  updateData.events = [event];
            }

            result = await this.apiService.updateOffer(this.editedOffer._id, updateData, purl);
         }

         if (result.logout)
            this.logout();
         else if (!result.message) {
            this.cancelDialogEdit();

            if (this.isActualEndpoint) {
               const result2 = await this.apiService.createEvent(result.data._id, event);
               if (result2.logout)
                  this.logout();
               // else if (!result.message)
               //    this.$emit('snackbar-event', `'${event.event_code}' event was created.`);
            }

            this.expandedItem = [];
            if (this.action === 'add') {
               this.$emit('snackbar-event', `'${result.data._id}' document was created.`);
               await this.filterChanged(this.filter, true);
            } else {               
               this.$emit('snackbar-event', `'${result.data._id}' document was updated.`);
               Object.keys(modifiedFields).forEach(key => {
                  if (this.offerHeaders.find(h => h.value === key))
                     this.editedOffer[key] = modifiedFields[key];
               });

               delete this.editedOffer.details;
               const offer = [this.editedOffer];
               await this.offerExpanded(offer, true); //to get offer's details
               // _alert('in submitDialogEdit(): offer=' + JSON.stringify(offer));
               // _alert('in submitDialogEdit(): editedOffer=' + JSON.stringify(this.editedOffer));
               this.editedOffer = offer[0];
            }
         }

         this.loadingDialogEdit = false;
      },

      cancelDialogEdit() {
         this.dialogEdit = false;
      },

      /********** Add Event **********/
      async getSettings() {
         let result = await this.apiService.getSettings();
         if (result.logout)
            this.logout();
         this.crm = result.data.crm || {};  //returns {} if there is no record
      },

      async addEventClicked(item) {
         this.editedOffer = item;
         // if (this.isActualEndpoint) {  //V221107.2
            const offer = [item];
            await this.offerExpanded(offer); //to get offer's details including events
            this.currEventCode = '';
            this.dialogAddEvent = true;

            const self = this;
            this.$nextTick(() => {
               self.$refs.addEventForm.reset();
               self.$refs.currEventCode.focus();
            });
         // }
      },

      eventCodeChanged(val) {
         // _alert('in eventCodeChanged(): val=' + val + '\ncrm=' + JSON.stringify(this.crm.event_data));
         this.eventFields = this.crm.event_data.filter(e => e.event_codes.includes(val));

         this.eventFields.forEach(ef => {
            // _alert('ef.type='+ef.type)
            ef.rules = [];
            if (ef.required) {
               if (ef.isMultiple)
                  ef.rules.push(this.rules.requiredArray);
               else if (ef.type === 'boolean')
                  ef.rules.push(this.rules.requiredBoolean);
               else
                  ef.rules.push(this.rules.required);
            }

            if (ef.type === 'number' && ef.step) {
               ef.options = [];
               for (let i = ef.min; i <= ef.max; i += ef.step) {
                  ef.options.push(i);
               }

               if (ef.options[ef.options.length - 1] != ef.max)
                  ef.options.push(ef.max);
            } else if (ef.type === 'boolean') {
               ef.options = [true, false];
               // _alert('ef=' + JSON.stringify(ef));
            } else if (ef.type != 'date') {
               if (hasOwn(ef, 'min'))
                  ef.rules.push(this.rules.minLength(ef));
               if (hasOwn(ef, 'max'))
                  ef.rules.push(this.rules.maxLength(ef));
               if (hasOwn(ef, 'regex'))
                  ef.rules.push(this.rules.custom(ef));
            }
         });

         // _alert('in eventCodeChanged(): eventFields=' + JSON.stringify(this.eventFields));

         const self = this;
         this.$nextTick(() => {
            self.$refs.addEventForm.validate();
            try {
               self.$refs.value_0_0[0].focus();
            } catch (error) {
               //do nothing
            }
         });
      },

      //not in use!
      // isSelect(ind) {
      //    const select = this.eventFields[ind].type === 'select' || Boolean(this.eventFields[ind].step);
      //    return select;
      // },

      eventTextFieldCleared(ind) {
         this.eventFields[ind].value = '';
      },

      async submitDialogAddEvent() {
         // _alert('in submitDialogAddEvent(): eventFields=' + JSON.stringify(this.eventFields));
         this.loadingAddEvent = true;
         const fieldsWithValue = {};
         this.eventFields.forEach(fld => {
            // if (fld.value != '')
            //    fieldsWithValue[fld.name] = fld.type === 'number' ? +fld.value : fld.value;
            if (fld.isMultiple) {
               // _alert('in submitDialogAddEvent(): fld=' + JSON.stringify(fld));
               if (fld.value && fld.value.length)
                  fieldsWithValue[fld.name] = fld.value.join(",");
            } else if (fld.type === 'boolean')
               fieldsWithValue[fld.name] = fld.value;
            else if (fld.value != '')
               fieldsWithValue[fld.name] = fld.type === 'number' ? +fld.value : fld.value;
         });

         // _alert('in submitDialogAddEvent(): fieldsWithValue=' + JSON.stringify(fieldsWithValue));

         const event = {
            app_code: this.crm.app_code,
            event_code: this.currEventCode,
            event_date: convertToISODate(new Date(), true),
            event_data: {
               ...fieldsWithValue,
               user: this.jwt.email
            }
         };

         // _alert('in submitDialogAddEvent(): event=' + JSON.stringify(event));

         let result;
         if (this.isActualEndpoint) {
            result = await this.apiService.createEvent(this.editedOffer._id, event);
         } else {
            const eventsObj = this.editedOffer.details.flat().find(d => d.key === 'events');
            const updateData = {
               events: [...(eventsObj ? eventsObj.value : []), event]
            };

            result = await this.apiService.updateOffer(this.editedOffer._id, updateData);
         }

         this.loadingAddEvent = false;
         if (result.logout)
            this.logout();
         else if (!result.message) {
            this.closeDialogAddEvent();
            this.$emit('snackbar-event', `'${event.event_code}' event was created.`);
            this.expandedItem = [];
            delete this.editedOffer.details;
         }
      },

      closeDialogAddEvent() {
         this.dialogAddEvent = false;
         this.eventFields.forEach(ef => {
            delete ef.value;
            delete ef.dateValue;
         });
      },

      async feedChanged(val) {
         // alert('isFeed=' + this.isFeed);
         // this.shouldInitFilterDefiner = false;
         // this.init();
         // this.loadingOffers = true;
         this.shouldInitFilterDefiner = false;

         if (val) {
            this.initialFilter = {};
            this.filter = this.btHelpers.getInitialFilter();   //columns will be added later on
            this.filter.columns = [...this.selectedHeaders];
            await this.filterChanged(this.filter, true);
            this.getFields();
            this.shouldInitFilterDefiner = true;
            this.footerProps.showFirstLastPage = false;
         } else {
            this.init();
         }
      },

      panelStatusChanged(val) {
         // alert(val);
         // we don't want to close the panel if it's already open
         this.closedOnLoad = !val;
      },

      //V240828
      getFields() {
         if (this.isFeed)
            this.fields = this.importHeaders.filter(h => h.isIndexed);
         else
            this.fields = [...this.importHeaders];
      },

      /********** Update Offers **********/
      async updateResultsClicked() {
         this.loadingUpdateBtn = true;
         const filter = this.btHelpers.getInitialFilter();
         filter.standard[0].$match.status = 'processing';
         this.numberOfOffers = '';

         if (!this.offerFields.length) {
            const offerFieldsResult = await this.btHelpers.getOfferFields(this.filter, this.stdFieldValues.importId);
            this.offerFields = offerFieldsResult.offerFields;
            this.offerFieldsTypeCasting = offerFieldsResult.typeCasting;
            this.updatableOfferFields = this.offerFields.filter(f => f.isUpdatable);
            this.updatableOfferFields.push(...[
               { text: '** Clear Events **', value: 'clear_events' },
               { text: '** Add Event **', value: 'add_event', type: 'date' }
            ]);

            this.types = ['string', 'number'];
            if (offerFieldsResult.typeCasting) {
               this.types.push('boolean');
               this.types.push('date');
            }
         }

         this.updatingOfferField = new UpdatingOfferField();
         this.loadingUpdateBtn = false;
         this.dialogUpdate = true;
         setTimeout(() => {
            this.$refs.numberOfOffers.focus();
         }, 100);
      },

      updatingOfferFieldChanged(selectedVal) {
         const val = typeof selectedVal === 'object' ? selectedVal.value : selectedVal;
         this.updatingOfferField = new UpdatingOfferField(val);
         const selectedOfferFld = this.updatableOfferFields.find(f => f.value === val);
         if (selectedOfferFld) {
            this.updatingOfferField.text = selectedOfferFld.text;
            this.updatingOfferField.type = selectedOfferFld.type;
            this.updatingOfferField.isTypeDisabled = selectedOfferFld.isTypeDisabled;
         }
         this.$refs['formUpdate'].validate();

         this.$nextTick(() => {
            if (this.updatingOfferField.name === 'add_event')
               this.$refs.appCode?.focus();
            else if (this.updatingOfferField.name != 'clear_events')
               this.$refs.value?.focus();
         });
      },

      cancelDialogUpdate() {
         this.dialogUpdate = false;
      },

      async submitDialogUpdate() {
         // alert(this.updatingOfferField.value + '\n' + typeof this.updatingOfferField.value + '\n' + this.updatingOfferField.value.length)
         if (!this.$refs['formUpdate'].validate())
            return;

         this.isUpdateInProcess = true;
         const dateStarted = new Date();
         const setIntervalUpdates = setInterval(() => {
            if (this.isUpdateInProcess)
               this.updateElapsedTime = _getElapsedTime(dateStarted);
            else
               clearInterval(setIntervalUpdates);
         }, 1000);

         const updateData = {
            filter: this.filter.standard.find(f => f.$match).$match,
            update: {},
            count: this.isFeed ? 0 : this.offersCount
         }

         if (this.updatingOfferField.name === 'clear_events') {
            updateData.update.events = [];
         } else if (this.updatingOfferField.name === 'add_event') {
            updateData.update.app_code = this.updatingOfferField.appCode;
            updateData.update.event_code = this.updatingOfferField.eventCode;
            updateData.update.event_date = this.updatingOfferField.value;
            // V260326: added
            if (this.updatingOfferField.eventPath?.trim())
               updateData.update.event_path = this.updatingOfferField.eventPath?.trim();
            if (this.updatingOfferField.eventElement?.trim())
               updateData.update.event_element = this.updatingOfferField.eventElement?.trim();
         } else {
            let castVal;
            if (this.updatingOfferField.type === 'number') {
               castVal = this.updatingOfferField.value.length > 16 ? this.updatingOfferField.value : +this.updatingOfferField.value;
            } else if (this.offerFieldsTypeCasting) {
               if (this.updatingOfferField.type === 'date')
                  castVal = this.updatingOfferField.dateValue;
            }

            updateData.update[this.updatingOfferField.name] = castVal === undefined ? this.updatingOfferField.value : castVal;
         }

         let result = await this.apiService.updateOffers(updateData);
         this.isUpdateInProcess = false;
         if (result.logout)
            this.logout();
         else if (!result.message) {
            this.$emit('snackbar-event', 'Your UPDATE request was submitted successfully. You can view its status and results on the Tags/Updates page.');  //V250924
            this.cancelDialogUpdate();
            //V250924: this.filterChanged(this.filter, true);
         }
      }
   },

   created() {
      DEBUG = this.debug;
      this.behFields = getAllBehavioralFields();
      this.behFieldsForGroupby = this.behFields.filter(f => f.value != 'ip' && f.value != 'pdid');
      this.init();
   }
}
</script>

<style scoped>
.expanded-header {
   font-style: italic;
   font-weight: bold;
}
div >>> .v-expansion-panel-content__wrap {
   padding: 16px 16px 0 !important;
}
div >>> .v-time-picker-clock__container {
   height: 285px;
}
div >>> .v-time-picker-title {
   height: 43px;
   padding-top: 0px;
   line-height: 0.9;
   font-size: 10px;
}
.v-expansion-panel-header, .v-expansion-panel-header--active {
   padding: 0 16px;
   min-height: 40px !important;
}
</style>
